(() => {
  const closePanels = () => {
    document.querySelectorAll("[data-site-panel]").forEach((panel) => {
      panel.classList.remove("is-open");
      panel.setAttribute("aria-hidden", "true");
    });

    document.querySelector("[data-site-overlay]")?.setAttribute("hidden", "");
    document.body.classList.remove("menu-open");
    document.querySelectorAll("[data-panel-trigger]").forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false");
    });
  };

  const openPanel = (name, trigger) => {
    const panel = document.querySelector(`[data-site-panel="${name}"]`);
    if (!panel) return;

    closePanels();
    panel.classList.add("is-open");
    panel.setAttribute("aria-hidden", "false");
    document.querySelector("[data-site-overlay]")?.removeAttribute("hidden");
    document.body.classList.add("menu-open");
    trigger?.setAttribute("aria-expanded", "true");

    if (name === "search") {
      window.setTimeout(() => panel.querySelector("input")?.focus(), 120);
    }
  };

  const closeFilters = () => {
    document.querySelectorAll("[data-filter-drawer]").forEach((drawer) => {
      drawer.classList.remove("is-open");
    });

    if (!document.querySelector("[data-site-panel].is-open")) {
      document.body.classList.remove("menu-open");
    }
  };

  const openFilters = () => {
    closePanels();
    document.querySelector("[data-filter-drawer]")?.classList.add("is-open");
    document.body.classList.add("menu-open");
  };

  const formatMoney = (amount, currency) =>
    new Intl.NumberFormat(document.documentElement.lang || "en-GB", {
      style: "currency",
      currency,
    }).format(amount / 100);

  const RECENTLY_VIEWED_KEY = "aa-recently-viewed";
  const RECENTLY_VIEWED_MAX = 12;

  const readRecentlyViewed = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(RECENTLY_VIEWED_KEY) || "[]");
      return Array.isArray(stored) ? stored : [];
    } catch {
      return [];
    }
  };

  const writeRecentlyViewed = (items) => {
    try {
      window.localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items.slice(0, RECENTLY_VIEWED_MAX)));
    } catch {
      // Ignore quota / private-mode failures.
    }
  };

  const escapeHtml = (value) =>
    String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");

  const recentlyViewedCard = (item) => {
    const currency = item.currency || "GBP";
    const onSale = item.compare_at_price > item.price;
    const image = item.image
      ? `<img class="product-card__primary" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.image_alt || item.title)}" loading="lazy" width="900" height="1200">`
      : `<div class="product-card__placeholder" aria-hidden="true"></div>`;
    const compareAt = onSale ? `<s>${formatMoney(item.compare_at_price, currency)}</s>` : "";

    return `
      <article class="product-card">
        <div class="product-card__media">
          <a href="${escapeHtml(item.url)}" aria-label="View ${escapeHtml(item.title)}">
            ${image}
          </a>
          ${onSale ? '<span class="product-card__badge">Sale</span>' : ""}
        </div>
        <a class="product-card__details" href="${escapeHtml(item.url)}">
          <p class="product-card__vendor">${escapeHtml(item.vendor || "Approved Attire")}</p>
          <h3>${escapeHtml(item.title)}</h3>
          <p class="product-card__price${onSale ? " product-card__price--sale" : ""}">
            <span>${formatMoney(item.price, currency)}</span>
            ${compareAt}
          </p>
        </a>
      </article>
    `;
  };

  const initializeRecentlyViewed = () => {
    document.querySelectorAll("[data-recently-viewed]").forEach((section) => {
      const currentScript = section.querySelector("[data-recently-viewed-current]");
      const grid = section.querySelector("[data-recently-viewed-grid]");
      if (!currentScript || !grid) return;

      let current = null;
      try {
        current = JSON.parse(currentScript.textContent);
      } catch {
        return;
      }
      if (!current?.id) return;

      const existing = readRecentlyViewed().filter((item) => item.id !== current.id);
      writeRecentlyViewed([current, ...existing]);

      const excludeId = Number(section.dataset.recentlyViewedExclude || current.id);
      const limit = Number(section.dataset.recentlyViewedLimit || 4);
      const items = readRecentlyViewed()
        .filter((item) => item.id !== excludeId)
        .slice(0, limit);

      if (!items.length) {
        section.hidden = true;
        grid.innerHTML = "";
        return;
      }

      grid.innerHTML = items.map(recentlyViewedCard).join("");
      section.hidden = false;
    });
  };

  const initializeProducts = () => {
    document.querySelectorAll("[data-product-root]:not([data-product-initialized])").forEach((root) => {
      root.setAttribute("data-product-initialized", "");
      const form = root.querySelector("[data-product-form]");
      const variantsElement = root.querySelector("[data-product-variants]");
      if (!form || !variantsElement) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsElement.textContent);
      } catch {
        return;
      }

      const updateOptionAvailability = (selectedOptions) => {
        form.querySelectorAll("[data-option-position]").forEach((fieldset) => {
          const optionIndex = Number(fieldset.dataset.optionPosition) - 1;
          fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
            const available = variants.some(
              (variant) =>
                variant.available &&
                variant.options.every((option, index) => {
                  if (index === optionIndex) return option === input.value;
                  return !selectedOptions[index] || option === selectedOptions[index];
                }),
            );
            input.disabled = !available;
            input.closest("label")?.classList.toggle("sizes__option--unavailable", !available);
          });
        });
      };

      const updateVariant = () => {
        const selectedOptions = [...form.querySelectorAll("[data-option-position]")].map(
          (fieldset) => fieldset.querySelector("input:checked")?.value || "",
        );
        updateOptionAvailability(selectedOptions);

        const variant = variants.find(
          (candidate) =>
            candidate.options.length === selectedOptions.length &&
            candidate.options.every((option, index) => option === selectedOptions[index]),
        );
        const idInput = form.querySelector("[data-variant-id]");
        const addButton = form.querySelector("[data-add-to-cart]");
        const error = form.querySelector("[data-variant-error]");

        if (!variant) {
          if (idInput) idInput.value = "";
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = "Unavailable";
          }
          if (error) error.textContent = "This option combination is unavailable.";
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? "Add to bag" : "Sold out";
        }
        if (error) error.textContent = "";

        const currency = root.dataset.currency || "GBP";
        const price = root.querySelector("[data-product-price]");
        const onSale = variant.compare_at_price > variant.price;
        if (price) {
          const compareAt = onSale ? `<s>${formatMoney(variant.compare_at_price, currency)}</s>` : "";
          price.innerHTML = `<span>${formatMoney(variant.price, currency)}</span>${compareAt}`;
          price.classList.toggle("product-price--sale", onSale);
        }

        const badge = root.querySelector("[data-product-badge]");
        if (badge) {
          const isNewProduct = badge.dataset.newProduct === "true";
          badge.textContent = onSale ? "Sale" : isNewProduct ? "New arrival" : "";
          badge.hidden = !onSale && !isNewProduct;
        }

        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);
      };

      form.addEventListener("change", (event) => {
        if (event.target.matches('[name^="option-"]')) updateVariant();
      });
      form.addEventListener("submit", (event) => {
        if (!form.querySelector("[data-variant-id]")?.value) event.preventDefault();
      });
      updateVariant();
    });
  };

  const initializeRecommendations = () => {
    document
      .querySelectorAll(
        "[data-product-recommendations][data-recommendations-url]:not([data-recommendations-loading])",
      )
      .forEach(async (section) => {
        section.setAttribute("data-recommendations-loading", "");

        try {
          const response = await fetch(section.dataset.recommendationsUrl);
          if (!response.ok) throw new Error("Unable to load product recommendations");

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, "text/html");
          const recommendations = documentFragment.querySelector("[data-product-recommendations]");

          if (recommendations?.innerHTML.trim()) {
            section.innerHTML = recommendations.innerHTML;
          }

          section.removeAttribute("data-recommendations-url");
        } catch {
          section.removeAttribute("data-recommendations-loading");
        }
      });
  };

  const initializeProductSliders = () => {
    document
      .querySelectorAll("[data-product-slider]:not([data-product-slider-initialized])")
      .forEach((root) => {
        root.setAttribute("data-product-slider-initialized", "");
        const track = root.querySelector("[data-product-slider-track]");
        const prev = root.querySelector("[data-product-slider-prev]");
        const next = root.querySelector("[data-product-slider-next]");
        if (!track) return;

        const updateControls = () => {
          const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
          const atStart = track.scrollLeft <= 2;
          const atEnd = track.scrollLeft >= maxScroll - 2;
          if (prev) prev.disabled = atStart || maxScroll <= 0;
          if (next) next.disabled = atEnd || maxScroll <= 0;
        };

        const scrollByCard = (direction) => {
          const card = track.querySelector(".product-card");
          const styles = window.getComputedStyle(track);
          const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
          const amount = (card?.getBoundingClientRect().width || track.clientWidth / 4) + gap;
          track.scrollBy({ left: direction * amount, behavior: "smooth" });
        };

        prev?.addEventListener("click", () => scrollByCard(-1));
        next?.addEventListener("click", () => scrollByCard(1));
        track.addEventListener(
          "scroll",
          () => {
            window.requestAnimationFrame(updateControls);
          },
          { passive: true },
        );
        window.addEventListener("resize", updateControls);
        updateControls();
      });
  };

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-panel-trigger]");
    if (trigger) {
      openPanel(trigger.dataset.panelTrigger, trigger);
      return;
    }

    if (event.target.closest("[data-close-panels]") || event.target.matches("[data-site-overlay]")) {
      closePanels();
      return;
    }

    if (event.target.closest("[data-filter-open]")) {
      openFilters();
      return;
    }

    if (event.target.closest("[data-filter-close]")) {
      closeFilters();
      return;
    }

    const mediaTrigger = event.target.closest("[data-media-src]");
    if (mediaTrigger) {
      openImageDialog(mediaTrigger);
      return;
    }

    if (event.target.closest("[data-image-prev]")) {
      stepImageDialog(-1);
      return;
    }

    if (event.target.closest("[data-image-next]")) {
      stepImageDialog(1);
      return;
    }

    if (event.target.closest("[data-size-guide]")) {
      document.querySelector("[data-size-dialog]")?.showModal();
      return;
    }

    const dialogClose = event.target.closest("[data-dialog-close]");
    if (dialogClose) {
      dialogClose.closest("dialog")?.close();
    }
  });

  let imageDialogState = {
    sources: [],
    index: 0,
  };

  const getImageDialog = () => document.querySelector("[data-image-dialog]");

  const renderImageDialog = () => {
    const dialog = getImageDialog();
    if (!dialog || !imageDialogState.sources.length) return;

    const image = dialog.querySelector("[data-image-dialog-img]");
    const count = dialog.querySelector("[data-image-dialog-count]");
    const current = imageDialogState.sources[imageDialogState.index];
    if (!image || !current) return;

    image.hidden = false;
    image.src = current.src;
    image.alt = current.alt || "";
    if (count) {
      count.textContent = `${imageDialogState.index + 1} / ${imageDialogState.sources.length}`;
    }
  };

  const stepImageDialog = (direction) => {
    const total = imageDialogState.sources.length;
    if (total < 2) return;
    imageDialogState.index = (imageDialogState.index + direction + total) % total;
    renderImageDialog();
  };

  const openImageDialog = (trigger) => {
    const dialog = getImageDialog();
    if (!dialog) return;

    const root = trigger.closest("[data-product-root]") || document;
    const slides = [...root.querySelectorAll("[data-gallery-slide][data-media-src]")];
    const triggers = slides.length ? slides : [...root.querySelectorAll("[data-media-src]")];

    imageDialogState.sources = triggers.map((item) => ({
      src: item.dataset.mediaSrc,
      alt: item.querySelector("img")?.alt || "",
    }));
    imageDialogState.index = Math.max(
      0,
      triggers.findIndex((item) => item === trigger || item.contains(trigger)),
    );

    renderImageDialog();
    dialog.showModal();
  };

  const initializeImageDialog = () => {
    const dialog = getImageDialog();
    if (!dialog || dialog.hasAttribute("data-image-dialog-initialized")) return;
    dialog.setAttribute("data-image-dialog-initialized", "");

    let touchStartX = 0;
    let touchStartY = 0;

    dialog.addEventListener(
      "touchstart",
      (event) => {
        if (!dialog.open || imageDialogState.sources.length < 2) return;
        const touch = event.changedTouches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      },
      { passive: true },
    );

    dialog.addEventListener(
      "touchend",
      (event) => {
        if (!dialog.open || imageDialogState.sources.length < 2) return;
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        stepImageDialog(deltaX < 0 ? 1 : -1);
      },
      { passive: true },
    );
  };

  const normalizeSizeToken = (value) => String(value || "").trim().toLowerCase();

  const sizeAliasMap = {
    xs: ["xs", "x small", "extra small"],
    s: ["s", "small"],
    m: ["m", "medium"],
    l: ["l", "large"],
    xl: ["xl", "x large", "extra large"],
    "2xl": ["2xl", "xxl", "2x large", "2xlarge"],
    "3xl": ["3xl", "xxxl", "3x large", "3xlarge"],
    "4xl": ["4xl", "4x large", "4xlarge"],
  };

  const expandSizeAliases = (values) => {
    const expanded = new Set();
    values.forEach((value) => {
      const token = normalizeSizeToken(value);
      if (!token) return;
      expanded.add(token);
      Object.entries(sizeAliasMap).forEach(([canonical, aliases]) => {
        if (canonical === token || aliases.includes(token)) {
          expanded.add(canonical);
          aliases.forEach((alias) => expanded.add(alias));
        }
      });
    });
    return expanded;
  };

  const usesFilterDrawer = () => window.matchMedia("(max-width: 900px)").matches;

  const buildCollectionFilterUrl = (form) => {
    let collectionUrl = form.dataset.collectionUrl;
    if (!collectionUrl) return null;

    const scopeKey = (scope) => {
      const checked = form.querySelector(
        `[data-filter-scope="${scope}"][data-filter-toggle]:checked`,
      );
      return checked?.dataset.filterKey || "";
    };

    try {
      const collectionMap = JSON.parse(form.dataset.collectionMap || "{}");
      const gender = scopeKey("gender");
      const range = scopeKey("range");
      const mapped =
        collectionMap[`${gender}|${range}`] ||
        collectionMap[`${gender}|`] ||
        collectionMap[`|${range}`];
      if (mapped) collectionUrl = mapped;
    } catch (_error) {
      // Keep the current collection URL if the map is unavailable.
    }

    const selectedTags = [...form.querySelectorAll("[data-filter-tag]")]
      .filter((input) => input.checked)
      .map((input) => input.dataset.filterTag)
      .filter(Boolean);

    const selectedSizes = [...form.querySelectorAll("[data-filter-size]")]
      .filter((input) => input.checked)
      .map((input) => input.dataset.filterSize || input.value)
      .filter(Boolean);

    const params = new URLSearchParams();
    form.querySelectorAll("input[name], select[name]").forEach((field) => {
      if (
        field.matches("[data-filter-tag]") ||
        field.matches("[data-filter-scope]") ||
        field.matches("[data-filter-size]") ||
        field.disabled
      ) {
        return;
      }
      if (field.type === "checkbox" || field.type === "radio") {
        if (field.checked) params.append(field.name, field.value);
        return;
      }
      if (field.value !== "") params.set(field.name, field.value);
    });

    if (selectedSizes.length) {
      params.set("sizes", selectedSizes.join(","));
    }

    const nextUrl = new URL(
      selectedTags.length ? `${collectionUrl}/${selectedTags.join("+")}` : collectionUrl,
      window.location.origin,
    );
    params.forEach((value, key) => nextUrl.searchParams.append(key, value));
    return nextUrl;
  };

  const applyCollectionFilters = async (form, { closeDrawer = false } = {}) => {
    if (!form) return;

    const nextUrl = buildCollectionFilterUrl(form);
    if (!nextUrl) {
      form.submit();
      return;
    }

    const sectionId = form.dataset.sectionId;
    const sectionEl = sectionId
      ? document.getElementById(`shopify-section-${sectionId}`)
      : null;

    if (!sectionId || !sectionEl) {
      window.location.href = `${nextUrl.pathname}${nextUrl.search}`;
      return;
    }

    const fetchUrl = new URL(nextUrl.toString());
    fetchUrl.searchParams.set("section_id", sectionId);
    sectionEl.classList.add("is-filter-loading");

    try {
      const response = await fetch(fetchUrl.toString(), {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok) throw new Error("Filter request failed");

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const newSection =
        doc.getElementById(`shopify-section-${sectionId}`) ||
        doc.querySelector("[data-collection-form]")?.closest(".shopify-section");

      if (!newSection) throw new Error("Filter section missing");

      sectionEl.innerHTML = newSection.innerHTML;
      history.pushState({}, "", `${nextUrl.pathname}${nextUrl.search}`);
      applyClientSizeFilter();
      initializeStickyOffset();

      if (closeDrawer || !usesFilterDrawer()) {
        closeFilters();
      } else if (usesFilterDrawer()) {
        openFilters();
      }
    } catch (_error) {
      window.location.href = `${nextUrl.pathname}${nextUrl.search}`;
    } finally {
      sectionEl.classList.remove("is-filter-loading");
    }
  };

  const readSelectedSizes = (form) => {
    if (form) {
      return [...form.querySelectorAll("[data-filter-size]")]
        .filter((input) => input.checked)
        .map((input) => input.dataset.filterSize || input.value)
        .filter(Boolean);
    }

    return (new URLSearchParams(window.location.search).get("sizes") || "")
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean);
  };

  const updateResultsCount = (visible) => {
    const count = document.querySelector(".results-count");
    if (!count) return;
    const base = Number(count.dataset.baseCount || "");
    const value = Number.isFinite(visible) ? visible : base;
    if (!Number.isFinite(value)) return;
    count.textContent = `${value} ${value === 1 ? "piece" : "pieces"}`;
  };

  const applyClientSizeFilter = (selectedSizes) => {
    const selected = Array.isArray(selectedSizes)
      ? selectedSizes
      : readSelectedSizes();
    const cards = document.querySelectorAll(".collection-grid .product-card[data-product-sizes]");
    if (!cards.length) return;

    if (!selected.length) {
      cards.forEach((card) => {
        card.hidden = false;
      });
      updateResultsCount(Number.NaN);
      return;
    }

    const wanted = expandSizeAliases(selected);
    let visible = 0;
    cards.forEach((card) => {
      const productSizes = expandSizeAliases((card.dataset.productSizes || "").split("|"));
      const matches = [...wanted].some((size) => productSizes.has(size));
      card.hidden = !matches;
      if (matches) visible += 1;
    });

    updateResultsCount(visible);
  };

  const syncSizeFilterFromForm = (form) => {
    if (!form) return;
    const selectedSizes = readSelectedSizes(form);
    const url = new URL(window.location.href);
    if (selectedSizes.length) {
      url.searchParams.set("sizes", selectedSizes.join(","));
    } else {
      url.searchParams.delete("sizes");
    }
    history.replaceState({}, "", `${url.pathname}${url.search}`);
    applyClientSizeFilter(selectedSizes);
  };

  document.addEventListener("change", (event) => {
    if (event.target.matches("[data-collection-sort]")) {
      applyCollectionFilters(event.target.closest("form"), { closeDrawer: true });
      return;
    }

    if (event.target.matches("[data-filter-toggle]")) {
      const input = event.target;
      const group = input.closest("[data-filter-toggle-group]");
      if (group && input.checked) {
        group.querySelectorAll("[data-filter-toggle]").forEach((other) => {
          if (other !== input) other.checked = false;
        });
      }
    }

    if (event.target.matches("[data-filter-auto-submit]")) {
      const form = event.target.closest("form");

      // Sizes are client-side — update the grid immediately and keep the drawer open.
      if (event.target.matches("[data-filter-size]")) {
        syncSizeFilterFromForm(form);
        return;
      }

      // Category / range / brand change the size scale — clear stale size picks
      // so clothing (XS–XL) and footwear (numeric) don't get mixed.
      form.querySelectorAll("[data-filter-size]").forEach((input) => {
        input.checked = false;
      });

      // Mobile: refresh results + size options via AJAX, but keep the drawer open.
      applyCollectionFilters(form, { closeDrawer: !usesFilterDrawer() });
    }
  });

  document.addEventListener("submit", (event) => {
    const form = event.target.closest("[data-collection-form]");
    if (!form?.dataset.collectionUrl) return;
    event.preventDefault();
    applyCollectionFilters(form, { closeDrawer: true });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closePanels();
      closeFilters();
    }

    const dialog = getImageDialog();
    if (!dialog?.open || imageDialogState.sources.length < 2) return;
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      stepImageDialog(-1);
    }
    if (event.key === "ArrowRight") {
      event.preventDefault();
      stepImageDialog(1);
    }
  });

  const initializeGalleries = () => {
    document.querySelectorAll("[data-product-gallery]:not([data-gallery-initialized])").forEach((gallery) => {
      gallery.setAttribute("data-gallery-initialized", "");
      const track = gallery.querySelector("[data-gallery-track]");
      const thumbsWrap = gallery.querySelector("[data-gallery-thumbs]");
      const slides = [...gallery.querySelectorAll("[data-gallery-slide]")];
      const thumbs = [...gallery.querySelectorAll("[data-gallery-thumb]")];
      if (!track || slides.length < 2 || !thumbs.length) return;

      const isMobileGallery = () => window.matchMedia("(max-width: 900px)").matches;

      const setActive = (index, { scrollThumb = true } = {}) => {
        thumbs.forEach((thumb, thumbIndex) => {
          const isActive = thumbIndex === index;
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-current", isActive ? "true" : "false");
        });

        if (scrollThumb && isMobileGallery() && thumbsWrap && thumbs[index]) {
          const thumb = thumbs[index];
          const left = thumb.offsetLeft - (thumbsWrap.clientWidth - thumb.clientWidth) / 2;
          thumbsWrap.scrollTo({ left: Math.max(0, left), behavior: "smooth" });
        }
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => {
          const index = Number(thumb.dataset.galleryThumb);
          const slide = slides[index];
          if (!slide || !isMobileGallery()) return;
          track.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
          setActive(index, { scrollThumb: false });
        });
      });

      let scrollFrame = 0;
      track.addEventListener(
        "scroll",
        () => {
          if (!isMobileGallery()) return;
          window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(() => {
            const width = track.clientWidth || 1;
            const index = Math.round(track.scrollLeft / width);
            setActive(Math.min(Math.max(index, 0), slides.length - 1));
          });
        },
        { passive: true },
      );

      if (thumbsWrap) setActive(0, { scrollThumb: false });
    });
  };

  const syncStickyOffset = () => {
    const headerGroup =
      document.querySelector(".shopify-section-group-header-group") ||
      document.querySelector(".site-header-wrap");
    if (!headerGroup) return;
    const height = Math.max(Math.ceil(headerGroup.getBoundingClientRect().height) - 3, 0);
    if (height > 0) {
      document.documentElement.style.setProperty("--sticky-offset", `${height}px`);
    }
  };

  let stickyOffsetFrame = 0;
  const scheduleStickyOffsetSync = () => {
    window.cancelAnimationFrame(stickyOffsetFrame);
    stickyOffsetFrame = window.requestAnimationFrame(syncStickyOffset);
  };

  const initializeStickyOffset = () => {
    syncStickyOffset();
    if (document.documentElement.hasAttribute("data-sticky-offset-ready")) return;
    document.documentElement.setAttribute("data-sticky-offset-ready", "");
    window.addEventListener("resize", scheduleStickyOffsetSync, { passive: true });
    window.addEventListener("orientationchange", scheduleStickyOffsetSync, { passive: true });
    if (window.ResizeObserver) {
      const headerGroup =
        document.querySelector(".shopify-section-group-header-group") ||
        document.querySelector(".site-header-wrap");
      if (headerGroup) {
        const observer = new ResizeObserver(scheduleStickyOffsetSync);
        observer.observe(headerGroup);
      }
    }
  };

  document.addEventListener("DOMContentLoaded", () => {
    initializeProducts();
    initializeRecommendations();
    initializeRecentlyViewed();
    initializeProductSliders();
    initializeGalleries();
    initializeImageDialog();
    applyClientSizeFilter();
    initializeStickyOffset();
  });
  document.addEventListener("shopify:section:load", () => {
    closePanels();
    closeFilters();
    initializeProducts();
    initializeRecommendations();
    initializeRecentlyViewed();
    initializeProductSliders();
    initializeGalleries();
    initializeImageDialog();
    applyClientSizeFilter();
    initializeStickyOffset();
  });

  initializeProducts();
  initializeRecommendations();
  initializeRecentlyViewed();
  initializeProductSliders();
  initializeGalleries();
  initializeImageDialog();
  applyClientSizeFilter();
  initializeStickyOffset();
})();
